const emptyBucket = { count: 0, amount: 0 }

export const emptyDisbursementBuckets = {
  approval_required: emptyBucket,
  trustee_approval_required: emptyBucket,
  agent_approval_required: emptyBucket,
  manager_approval_required: emptyBucket,
  approved: emptyBucket,
  in_transit: emptyBucket,
  payment_initiated: emptyBucket,
  paid: emptyBucket,
  cancelled: emptyBucket,
  failed: emptyBucket,
  returned: emptyBucket
}

export const emptyPaymentBuckets = {
  PAYMENT_INITIATED: emptyBucket,
  COMPLETED: emptyBucket,
  FAILED: emptyBucket,
  RETURNED: emptyBucket
}

export const mockDisbursementBatchProgress = {
  data: {
    currencyCode: 'USD',
    disbursements: {
      ...emptyDisbursementBuckets,
      approved: { count: 4, amount: 120_000 },
      payment_initiated: { count: 71, amount: 2_130_000 },
      paid: { count: 18, amount: 600_000 },
      failed: { count: 2, amount: 150_000 }
    },
    payments: {
      ...emptyPaymentBuckets,
      PAYMENT_INITIATED: { count: 71, amount: 2_130_000 },
      COMPLETED: { count: 18, amount: 600_000 },
      FAILED: { count: 2, amount: 150_000 }
    }
  },
  object: 'disbursement_batch_progress'
}

export const mockDisbursementBatchProgressEmpty = {
  data: {
    currencyCode: 'USD',
    disbursements: emptyDisbursementBuckets,
    payments: emptyPaymentBuckets
  },
  object: 'disbursement_batch_progress'
}
